
import { BookingService } from 'src/app/services/booking.service';
import { Component, Input, OnInit } from '@angular/core';
import { faArrowLeft, faBriefcase, faTimesCircle,faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'vehicle-card-abstract',
  templateUrl: './vehicle-card-abstract.component.html',
  styleUrls: ['./vehicle-card-abstract.component.css']
})
export class VehicleCardAbstractComponent implements OnInit {
  faTimesCircle = faTimesCircle;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faArrowLeft = faArrowLeft
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  @Input() vehicle;
  bookedVehicle;
  constructor(private bookingService:BookingService) {


  }

  ngOnInit() {

  }

}
